module.exports = __webpack_public_path__ + "img/no-producers.09d3dd6f.svg";